import clsx from 'clsx'

export default function HamburgerIcon({
	isMobileMenuOpen,
}: Readonly<{ isMobileMenuOpen: boolean }>) {
	return (
		<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="14"
				y="20"
				width="20"
				height="1.5"
				fill="white"
				className={clsx(
					isMobileMenuOpen ? 'rotate-[45deg] translate-y-[2px] translate-x-[-2px]' : 'rotate-0',
					'transition-transform duration-300 origin-center'
				)}
			/>
			<rect
				width="20"
				height="1.5"
				x="14"
				y="28"
				fill="white"
				className={clsx(
					isMobileMenuOpen
						? 'rotate-[-45deg] translate-y-[-3.5px] translate-x-[-3.5px]'
						: 'rotate-0',
					'transition-transform duration-300 origin-center'
				)}
			/>
		</svg>
	)
}
